import { render, staticRenderFns } from "./CardCost.vue?vue&type=template&id=9e56ea86&scoped=true&"
import script from "./CardCost.vue?vue&type=script&lang=ts&"
export * from "./CardCost.vue?vue&type=script&lang=ts&"
import style0 from "./CardCost.vue?vue&type=style&index=0&id=9e56ea86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e56ea86",
  null
  
)

export default component.exports